import { ZohoActions } from "../redux/zoho/actions";
import { EMPTY, Observable, of } from "rxjs";
import { ZohoApi } from "../api/zoho-api";
import { catchError, map, mergeMap } from "rxjs/operators";
import {
    ZohoPhaseFile,
    ZohoPhaseFileDone,
    ZohoPhaseFileExtra,
    ZohoPhaseFileExtraDone,
    ZohoPhaseFour,
    ZohoPhaseFourDone,
    ZohoPhaseOne,
    ZohoPhaseOneDone,
    ZohoPhaseThree,
    ZohoPhaseThreeDone,
    ZohoPhaseTwo,
    ZohoPhaseTwoDone,
} from "../redux/zoho/actions/default";
import { TYPE_PHASES } from "../libs/zoho/constants";
import { PhaseOneParameters } from "../libs/zoho/models/PhaseOne";
import { env } from "../libs/utils/env";
import { RootState } from "../redux/reducers";
import { get } from "lodash";

let blackList: string[];

const isChannelInBlackList = (state: Partial<RootState>) => {
    if (!blackList) {
        blackList = env.array<string>(process.env.REACT_APP_ZOHO_BLACKLIST);
    }
    if (blackList.includes(get(state, "page.channels.channel"))) {
        return true;
    }
    return false;
};

export class ZohoRepository {
    static getOpportunity(action: any, partyId: number) {
        const payload = {
            ...action.payload,
            partyId,
        };
        return ZohoApi.getOpportunity(payload as PhaseOneParameters).pipe(
            map((response) => new ZohoPhaseOneDone(response).create()),
            catchError((err) => of(new ZohoPhaseOneDone(err).create()))
        );
    }
    static saveZohoPhaseOne(
        action: ZohoPhaseOne,
        state: Partial<RootState> = {}
    ): Observable<ZohoActions> {
        if (isChannelInBlackList(state)) {
            return EMPTY;
        }
        return ZohoApi.getCustomer(action.payload as PhaseOneParameters).pipe(
            mergeMap((responseGet) => {
                const partyId = responseGet.partyId;
                if (!partyId) {
                    return ZohoApi.createCustomer(
                        action.payload as PhaseOneParameters
                    ).pipe(
                        mergeMap((responseCreate) => {
                            return ZohoRepository.getOpportunity(
                                action,
                                responseCreate.PartyId
                            );
                        })
                    );
                } else {
                    return ZohoRepository.getOpportunity(action, partyId);
                }
            })
        );
    }

    static saveZohoPhaseTwo(
        action: ZohoPhaseTwo,
        state: Partial<RootState> = {}
    ): Observable<ZohoActions> {
        if (isChannelInBlackList(state)) {
            return EMPTY;
        }
        return ZohoApi.updatePhase(TYPE_PHASES.PHASE_TWO, action.payload).pipe(
            map(({ response }) => new ZohoPhaseTwoDone(response).create()),
            catchError((err) => of(new ZohoPhaseTwoDone(err).create()))
        );
    }

    static saveZohoPhaseThree(
        action: ZohoPhaseThree,
        state: Partial<RootState> = {}
    ): Observable<ZohoActions> {
        if (isChannelInBlackList(state)) {
            return EMPTY;
        }
        return ZohoApi.updatePhase(
            TYPE_PHASES.PHASE_THREE,
            action.payload
        ).pipe(
            map(({ response }) => new ZohoPhaseThreeDone(response).create()),
            catchError((err) => of(new ZohoPhaseThreeDone(err).create()))
        );
    }

    static saveZohoPhaseFour(
        action: ZohoPhaseFour,
        state: Partial<RootState> = {}
    ): Observable<ZohoActions> {
        if (isChannelInBlackList(state)) {
            return EMPTY;
        }
        return ZohoApi.updatePhase(TYPE_PHASES.PHASE_FOUR, action.payload).pipe(
            map(({ response }) => new ZohoPhaseFourDone(response).create()),
            catchError((err) => of(new ZohoPhaseFourDone(err).create()))
        );
    }

    static saveZohoPhaseFile(
        action: ZohoPhaseFile,
        state: Partial<RootState> = {}
    ): Observable<ZohoActions> {
        if (isChannelInBlackList(state)) {
            return EMPTY;
        }
        return ZohoApi.updatePhase(TYPE_PHASES.PHASE_FILE, action.payload).pipe(
            map(({ response }) => new ZohoPhaseFileDone(response).create()),
            catchError((err) => of(new ZohoPhaseFileDone(err).create()))
        );
    }

    static saveZohoPhaseFileExtra(
        action: ZohoPhaseFileExtra,
        state: Partial<RootState> = {}
    ): Observable<ZohoActions> {
        if (isChannelInBlackList(state)) {
            return EMPTY;
        }
        return ZohoApi.updatePhase(
            TYPE_PHASES.PHASE_EXTRA_FILE,
            action.payload
        ).pipe(
            map(({ response }) =>
                new ZohoPhaseFileExtraDone(response).create()
            ),
            catchError((err) => of(new ZohoPhaseFileExtraDone(err).create()))
        );
    }
}
